import { standardBlueprint } from './standardBlueprint';

export { standardBlueprint };
export const blueprintVersions = [standardBlueprint] as const;

export const standardBlueprintVersion = standardBlueprint.version;
